/**
 * 회사 정보 푸터 — 사업자 정보 / 통신판매중개 면책
 * 홈 화면 하단에 노출
 */
import React from 'react';
import styled from 'styled-components';

const CompanyFooter = () => (
  <Wrap>
    <Title>주식회사 홍컴즈</Title>
    <ServiceLine>학원 관리·소통 서비스 '일등급(일등급학원)' 운영</ServiceLine>
    <InfoLine>
      대표자명: 이행렬 | 주소: 서울특별시 서초구 사임당로8길 13, 4층 | 전자우편: kkan2222@gmail.com | 호스팅 사업자: 주식회사 홍컴즈
    </InfoLine>
    <InfoLine>전화번호: 010-6214-9756</InfoLine>
    <InfoLine>사업자등록번호: 480-86-03245 | 통신판매업 신고번호: 2024-다산-0881</InfoLine>
    <Notice>
      (주)홍컴즈는 통신판매중개자이며, 통신판매의 당사자가 아닙니다.
      따라서, 학원 정보·예약·결제 및 환불 등과 관련한 책임을 지지 않습니다.
    </Notice>
  </Wrap>
);

export default CompanyFooter;

const Wrap = styled.footer`
  margin-top: 40px;
  padding: 8px 22px 40px;
  background: #fff;
  line-height: 1.7;
`;

const Title = styled.p`
  font-size: 15px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 10px;
`;

const ServiceLine = styled.p`
  font-size: 12.5px;
  font-weight: 600;
  color: #4B5563;
  margin-bottom: 8px;
`;

const InfoLine = styled.p`
  font-size: 12px;
  color: #6B7280;
`;

const Notice = styled.p`
  margin-top: 14px;
  font-size: 11.5px;
  color: #9CA3AF;
  line-height: 1.6;
`;
